<template>

  <div class="height-100">
    <JobSeekerJumbotron v-if="!webset" />
    <div class="hflex" v-else>
      <div class="hflex-col-5 hflex-options-left">
        <div
          v-if="!webset.profiles.docs.length"
          class="p-3">
          <span class="text-muted">
            {{ isRunning ? $t('Busca em andamento...') : $t('Nenhum resultado encontrado') }}
          </span>
        </div>
        <JobSeekerList
          :profiles="webset.profiles"
          :job="job" />
      </div>
      <div class="hflex-col-5">
        <JobSeekerProfile
          v-if="currentProfile"
          :profile="currentProfile"
          :key="currentProfile ? currentProfile._id : null" />
      </div>
    </div>
  </div>

</template>

<script>
import JobSeekerList from './JobSeekerList'
import JobSeekerJumbotron from './JobSeekerJumbotron'
import JobSeekerProfile from './JobSeekerProfile'

export default {
  name: 'JobSeekerResult',
  components: {
    JobSeekerList,
    JobSeekerJumbotron,
    JobSeekerProfile
  },
  props: {
    webset: {
      type: Object,
      required: true
    },
    job: {
      type: Object,
      required: true
    },
    currentProfile: {
      type: Object,
      required: false
    },
    isRunning: {
      type: Boolean,
      default: false
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Job/JobSeeker/JobSeekerResult.vue